<template lang="pug">
.light-grey
  .header-container
    b-container
      b-row
        b-col(lg="7" md="12")
          Message(
            :fontSizes="fontSizes"
            title="The optimal fact base for your key decisions"
            subtitle="We use algorithmic information retrieval to extract impactful insights from the overload of data available online. We deliver user-friendly and interactive summary dashboards to support private market investors and business executives in their decision-making."
            button="Contact Us"
          )
        b-col(col class="d-none d-lg-block" lg="5")
          img.header-picture(src="@/assets/imagesnew/ipad-min.png")
</template>

<script>
import Message from '@/components/Shared/Message.vue'
import Navbar from '@/components/Shared/Navbar.vue'

export default {
  name: 'Header',
  components: {
    Message,
    Navbar
  },
  props: {
    type: String,
    default: ''
  },
  methods: {
    scrollToSection (section) {
      this.$emit('scrollTo', section)
    }
  },
  computed: {
    fontSizes () {
      if (window.innerWidth > 991) {
        return [50, 24, 16]
      } else if (window.innerWidth > 576) {
        return [40, 20, 15]
      } else {
        return [25, 16, 14]
      }
    }
  }

}

</script>

<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;

.header-container{
  background: url("../../assets/imagesnew/hp-bg-img.jpg");
  background-size: 44% 100%;
  background-position: right;
  background-repeat: no-repeat;
  overflow: hidden;
}

.header-picture {
  margin-left: 7vw;
  margin-top: 15vh;
  width: 50vw;
}

@media only screen and (max-width: 767px) {
/* smartphone */
  .header-picture {
    visibility: hidden;
  }

  .header-container{
  background: url("../../assets/imagesnew/hp-bg-img.jpg");
  background-size: 44% 50%;
  background-position: bottom right;
  background-repeat: no-repeat;
  overflow: hidden;
}
}


</style>
